export default __webpack_public_path__ + "static/media/Armguards of the Black Dragon.3727eb5a.jpg";